import React from 'react';

function PackageCard({ label, price, name, features, onRequest }) {
	return (
		<article className="tax-package-card">
			<div className="tax-package-card__top">
				<h3 className="tax-package-card__label">{label}</h3>
				<p className="tax-package-card__price">{price}</p>
			</div>
			<p className="tax-package-card__title">{name}</p>
			<ul className="tax-package-card__list">
				{features.map((feature) => (
					<li key={feature}>{feature}</li>
				))}
			</ul>
			<button
				className="tax-package-card__action"
				type="button"
				onClick={() => onRequest({ label, price, name })}
			>
				Send Your Request
			</button>
		</article>
	);
}

export default function TaxServicesPackageGroup({ title, packages, onRequest }) {
	return (
		<section className="tax-package-group">
			<div className="tax-package-group__header">
				<h2>{title}</h2>
			</div>
			<div className="tax-package-group__grid">
				{packages.map((packageItem) => (
					<PackageCard key={`${title}-${packageItem.label}`} {...packageItem} onRequest={onRequest} />
				))}
			</div>
		</section>
	);
}